<div class="container_large" data-bb="summaryPageLarge">
    <section class="ap-justify-content-center ap-flex">
        <div class="ap-text-align-center">
            <ap-animation
                class="ap-align-items-center"
                data-bb="transaction-result-animation"
                [name]="resultAnimation"
                width="100px"
                height="100px"
            >
            </ap-animation>
        </div>
    </section>
</div>

<div class="container_small" data-bb="summaryPageLarge">
    <section class="ap-justify-content-center ap-flex">
        <div class="ap-text-align-center ap-margin-bottom-4 ap-display-block">
            <h1 data-bb="transaction-result-title">{{ resultTitle }}</h1>
            <p data-bb="transaction-result-message">{{ resultMessage }}</p>
        </div>
    </section>
</div>
